__turbopack_context__.v({
  "content": "styles-module-scss-module__f0uqNG__content",
  "cookieConsent": "styles-module-scss-module__f0uqNG__cookieConsent",
  "cookieImage": "styles-module-scss-module__f0uqNG__cookieImage",
  "termsLink": "styles-module-scss-module__f0uqNG__termsLink",
});
